import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WebsocketNotificationService {
  private _reservationEndpoint = "/output/reservation";
  private _orderEndpoint = "/output/order";
  private _closingHoursEndpoint = "/output/closing-hours"
  private _eventEndpoint = "/output/makery-event"
  public unreadCount = 0;
  private _reloadKey = [
    // "ADD_RESERVATION",
    // "ADD_DELIVERY",
    "UPDATE_RESERVATION",
    // "UPDATE_DELIVERY",
    "ADD_NOTE",
    // "STATUS_CHANGE_DELIVERY",
    // "STATUS_CHANGE_PENDING",
    "STATUS_CHANGE_ACCEPT",
    "STATUS_CHANGE_SUCCESS",
    "STATUS_CHANGE_NOT_ARRIVED",
    "STATUS_CHANGE_DECLINE",
    "UPDATE_GUEST",
    "POSTPONE_RESERVATION"
  ];

  constructor() {
  }

  get reservationEndpoint(): string {
    return this._reservationEndpoint;
  }

  get reloadKey(): string[] {
    return this._reloadKey;
  }
}

export interface BroadcastPayload {
  type: string;
  subscribePath: string;
  attribute: any;
}

